import React from 'react';
import styled from 'styled-components';

import { Action } from 'state';
import { colors } from 'theme';
import Field from 'types/Field';
import Section from 'types/Section';
import FieldPreview from './FieldPreview';

const StyledNestedSelectFieldPreview = styled.div`
  margin-left: 1.25rem;
  padding: 0.4rem 0 0 0.8rem;

  border-left: solid 2px ${colors.grey_200};

  & > *:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

interface NestedSelectFieldPreviewProps {
  field: Field;
  section: Section;
  dispatch: (action: Action) => void;
}

const NestedSelectFieldPreview: React.FC<NestedSelectFieldPreviewProps> = ({ section, field, dispatch }) => {
  return (
    <StyledNestedSelectFieldPreview>
      <FieldPreview field={field} section={section} dispatch={dispatch} />
    </StyledNestedSelectFieldPreview>
  );
};

export default NestedSelectFieldPreview;
